module.exports = __webpack_public_path__ + "static/media/bottom-notch.dadd732b.svg";